<script>
import App from './App.svelte';

	import Breakpoint from './components/Breakpoint.svelte';
    import { postData } from './scripts';

	export let params = {}
    let idenvio=(params.idenvio)?params.idenvio:'';

    let boxClientSelected=0;
    
    let emails=(params.email)?params.email:'ventas@email.com.gt';
    //let emails=(params.email)?params.email:boxClient[0].emails.join("\n").toLowerCase();

    let boxClient=[
        {name:'General', emails:emails},
    ]
    let boxClientBackup=[...boxClient];
/*    let boxClient=[
        {name:'General', emails:emails,checked:true },
        {name:'Alvaro', emails:['ventas@email.com.gt','alvaro@email.com.gt']},
        {name:'Silvia', emails:['ventas@guatemalanetworks.com','silvia@email.com.gt']}
    ]    */

    let idcliente=''
    let nombre=''
    let asunto=''

    let disabled=false;
    let field_emails=null;
    let field_emails_asignado=false;
    let retardo=null;
    let notificaciones=[];

    let disabled_save=true;
    let button_save='Guardar';
    let button_save_icon='<i class="bi bi-save me-1"></i>';
    let cliente_encontrado=false;
    let nameTab=null;

    $: if(boxClientSelected!==false)
    {
        updateFieldEmail()
    }

    if(idenvio!='')
    {
        parseEmails()
        loadEnvio()
    }

    function eliminarPestana()
    {
        console.log(boxClientSelected)
        boxClient.splice(boxClientSelected, 1)
        boxClientSelected=0;
        boxClient=[...boxClient]
    }
    
    function agregarPestana()
    {
        let nueva=[{name:'Nueva', emails:[]}]
        boxClient=[...boxClient,...[{name:'Nueva', emails:[]}]];
        boxClientSelected=boxClient.length-1;
        setTimeout(() => {
            nameTab.focus();
            nameTab.select();
        }, 200);        
    }

    function updateFieldEmail()
    {
        if(Array.isArray(boxClient[boxClientSelected].emails))
        {
            emails=boxClient[boxClientSelected].emails.join("\n").toLowerCase();
        } else {
            emails=boxClient[boxClientSelected].emails.toLowerCase();
        }
    }

    function GuardarEmails()
    {
        parseEmails()
        
        let emailTMP=[];
        if(boxClient.length>1)
        {
            emailTMP=[...boxClient]
            emailTMP.shift()
        } else {
            emailTMP=[{name:'Guardado', emails:emails}]
        }
        disabled_save=true;
        button_save='Guardando...';
        button_save_icon='<div class="spinner-border spinner-border-sm me-1" role="status"><span class="visually-hidden">Loading...</span></div>';

        addNotificacion('Guardando emails del cliente <strong>'+nombre+'</strong>',false)

        postData("https://emailgt.com/emac/api/saveEmailCliente.php", {
            pass: "22851387",
            idcliente:idcliente,
            email:JSON.stringify(emailTMP)
        }).then((data) => {
            addNotificacionSuccess('Emails Guardados')
            disabled_save=false;
            button_save='Guardar';
            button_save_icon='<i class="bi bi-save me-1"></i>';
        });

    }


    $: if(emails)
    {
        if(null != field_emails && field_emails_asignado===false)
        {
            field_emails.style.height='auto;';
            field_emails.style.height=(field_emails.scrollHeight+10) + "px";

            field_emails.style.boxSizing = 'border-box';
            let offset = field_emails.offsetHeight - field_emails.clientHeight;
            field_emails.addEventListener('input', function (event) {
                field_emails.style.height = 'auto';
                field_emails.style.height = field_emails.scrollHeight + offset + 'px';
            });
            field_emails_asignado=true;
        }
    }
    
	function validate() {
        disabled=true;
        disabled_save=true;
        parseEmails();

        let myemails=extractEmails(emails);
        let ultimoIndex=myemails.length-1;
        
        myemails.forEach(function(element, index, array){

            postData("https://pruebas.email.com.gt/email/email.php", {
                idenvio:idenvio,
                idcliente:idcliente,
                nombre:nombre,
                asunto:asunto,
                email:element
            }).then((data) => {

                addNotificacionSuccess('El email <strong>'+element+'</strong> fue enviado')

                if(index==ultimoIndex)
                {
                    disabled_save=false;
                    disabled=false;
                    verifySave()
                }
            });            
        });
      
	}

    function verifySave()
    {
        if(cliente_encontrado===true)
        {
            disabled_save=false;
        } else {
            disabled_save=true;
        }
    }

    function extractEmails(text)
    {
        if(text=='') return [];
        return text.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi);
    }
    function parseEmails()
    {
        emails=[...new Set(extractEmails(emails.toLowerCase()))].join('\n');
        boxClient[boxClientSelected].emails=[...new Set(extractEmails(emails.toLowerCase()))];
    }

    const onKeyPress = e => {
        if(retardo!==null) clearTimeout(retardo);
        retardo=setTimeout(() => {
            loadEnvio()
        }, 1000);
    };

    function loadEnvio()
    {
        if(idenvio=='')
        {
            idcliente='';
            asunto='';
            nombre='';
            cliente_encontrado=false;
            verifySave()
            return;
        }

        disabled=true;
        addNotificacion('Cargando información del envio <strong>'+idenvio+'</strong>',false)

        postData("https://emailgt.com/emac/api/envio.php", {
            pass: "22851387",
            idenvio:idenvio
        }).then((data) => {
            if(data.error===false)
            {
                addNotificacion('Datos cargados del envio <strong>'+idenvio+'</strong>',false)
                idcliente=data.idcliente;
                asunto=data.asunto;
                nombre=data.nombre;
                cliente_encontrado=true;
                boxClient=[...boxClientBackup];
                boxClient=[...boxClient,...JSON.parse(data.emails)]
                boxClientSelected=0;

                //emails_cliente=JSON.parse(data.emails);

                //let clientes=[{name:'General',emails:['ventas@email.com.gt']}]
                //emails=(params.email)?params.email:clientes[0].emails.join("\n").toLowerCase();
            } else {
                addNotificacion('Error al cargar información del envio <strong>'+idenvio+'</strong>',true)
                idcliente='';
                asunto='';
                nombre='';
                cliente_encontrado=false;
                //emails_cliente=[];
            }
            disabled=false;
            verifySave()
        });
    }

    function addNotificacion(text,error)
    {
        if(error===true)
        {
            text='<span class="p-1 bg-danger text-white"><i class="bi bi-exclamation-octagon me-1"></i>'+text+'<strong></span>'
        } else {
            text='<span class="p-1"><i class="bi bi-info-square me-1"></i>'+text+'<strong></span>'
        }
        //console.log(notificaciones.length)
        //if(notificaciones.length>15) notificaciones.length=15;
        notificaciones=[text,...notificaciones]
    }
    function addNotificacionSuccess(text)
    {
        text='<span class="p-1 bg-success"><i class="bi bi-check-lg me-1"></i>'+text+'<strong></span>'
        notificaciones=[text,...notificaciones]
    }

</script>
<Breakpoint/>
<div class="container">
    <div class="row">
        <div class="col-12 mt-2 mb-2">
            <h4 class='text-verde fw-bold border-bottom'>ENVIO DE CORREO DE PRUEBA</h4>
        </div>
    </div>
    <form on:submit|preventDefault={validate}>
        <div class="row">
            <div class='col-12 col-lg-5'>
                <div class="row">
                    <div class='col-6'>
                        <div class="mb-3">
                            <label for="field_idenvio" class="form-label text-verde">IDENVIO</label>
                            
                            <div class="input-group mb-3">
                                <input {disabled} on:keydown={onKeyPress} bind:value={idenvio} type="text" class="form-control" id="field_idenvio" placeholder="IDENVIO">
                                <button on:click={loadEnvio} class="btn btn-success bg-verde text-white" type="button" id="button-addon2"><i class="bi bi-arrow-repeat"></i></button>
                            </div>

                        </div>
                    </div>
                    <div class='col-6'>
                        <div class="mb-3">
                            <label for="field_idcliente" class="form-label text-verde">IDCLIENTE</label>
                            <input {disabled} readonly bind:value={idcliente} type="text" class="form-control" id="field_idcliente" placeholder="IDCLIENTE">
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <label for="field_nombre" class="form-label text-verde">NOMBRE DEL CLIENTE</label>
                    <input {disabled} bind:value={nombre} type="text" class="form-control" id="field_nombre" placeholder="Escribir NOMBRE DEL CLIENTE">
                </div>
                <div class="mb-3">
                    <label for="field_asunto" class="form-label text-verde">ASUNTO</label>
                    <input {disabled} bind:value={asunto} type="text" class="form-control" id="field_asunto" placeholder="Escribir ASUNTO">
                </div>

            </div>
            <div class='col-12 col-lg-7'>

                <div class="mb-3">

                    <label for="field_emails" class="form-label text-verde">EMAILS PARA ENVIAR</label>

                    <div class="mb-3 d-flex justify-content-end">
                        <button {disabled} type="button" on:click={parseEmails} class="btn btn-warning btn-sm   me-1"><i class="bi bi-code-square me-1"></i>Parser</button>
                        
                        {#if disabled_save==true}
                            <button disabled type="button" class="btn btn-success btn-sm">{@html button_save_icon}{button_save}</button>
                        {:else}
                            <button type="button" on:click={GuardarEmails} class="btn btn-success btn-sm">{@html button_save_icon}{button_save}</button>
                        {/if}
                        
                    </div>
                    
                    <div class="btn-group btn-group-sm" role="group" aria-label="Basic radio toggle button group">

                        {#each boxClient as item,index}
                            <input bind:group={boxClientSelected} on:click={()=>{ boxClientSelected=index }} value={index} type="radio" class="btn-check" name="btnradio" id="btnradio{index}" autocomplete="off">
                            <label class="btn btn-outline-secondary tabClients" for="btnradio{index}" id='labelradio{index}'>{@html item.name}</label>
                        {/each}
                    </div>
                    
                    <textarea on:blur={parseEmails} {disabled} bind:this={field_emails} bind:value={emails} class="form-control" id="field_emails" ></textarea>

                        <div class="input-group input-group-sm mb-3 mt-2">
                            {#if boxClientSelected!=0}
                                <input {disabled} bind:this={nameTab} bind:value={boxClient[boxClientSelected].name} type="text" class="form-control" placeholder="Escribir nombre Pestaña">
                            {:else}
                                <input disabled bind:value={boxClient[boxClientSelected].name} type="text" class="form-control" placeholder="Escribir nombre Pestaña">
                            {/if}
                            {#if boxClientSelected!=0}
                                <button on:click={eliminarPestana} {disabled} class="btn btn-danger " type="button" id="button-addon2"><i class="bi bi-x-lg me-1"></i>Pestaña</button>
                            {/if}
                            <button on:click={agregarPestana} {disabled} class="btn btn-success bg-verde text-white" type="button" id="button-addon2"><i class="bi bi-plus-lg me-1"></i>Pestaña</button>                            
                        </div>

                </div>
                <div class="mb-3 ">
                    <button {disabled} type="submit" class="btn btn-white bg-verde text-white">
                        {#if disabled===false}
                            <i class="bi bi-envelope me-1"></i>Enviar
                        {:else}
                            <div class="spinner-border spinner-border-sm" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            Enviando...
                        {/if}
                    </button>
                    <button type="button" on:click={()=>emails=''} class="btn btn-danger btn-sm"><i class="bi bi-x-circle me-1"></i>Vaciar</button>
                    <!-- svelte-ignore a11y-missing-attribute -->
                    <a on:click={()=>emails='ventas@email.com.gt'}  class='ms-1 text-verde' style='cursor:pointer'>ventas@email.com.gt</a>
                </div>
            </div>        
        </div>

    </form>
    
    <div class='row mt-4'>
        <div id='notificaciones' class="col-12 bg-secondary text-white pt-2 pb-2">
            {#each notificaciones as item}
                 <p class='border-bottom mb-0 pb-1 pt-1'>{@html item}</p>
            {:else}
                <p class='border-bottom mb-0 pb-1 pt-1'>Sin acciones</p>
            {/each}
        </div>
        <div class='mt-3 col-12 ps-0'>
            <button type="button" on:click={()=>notificaciones=[]} class="btn btn-danger btn-sm"><i class="bi bi-x-circle me-1"></i>Vaciar</button>
        </div>
    </div>

</div>
<br/><br/>
<style>
    label#labelradio0 {
        color: var(--bs-green) !important;
        font-weight:bold;
        margin-left:5px;
    }
    label.tabClients {
        border-bottom-right-radius: 0px;
        border-bottom-left-radius: 0px;
        border-bottom: 0px none;
    }
    :root {
        --bs-warning: #f00 !important;
    }
    .text-verde {
        color: var(--bs-green);
    }
    .bg-verde {
        background-color: var(--bs-green);
        border-color: var(--bs-green);
    }    
    textarea {
        resize:none;
        height:auto;
        min-height:150px !important;
    }
    DIV#notificaciones {
        height:250px;
        overflow: auto;
    }
</style>